<template lang="pug">
  Preview(
    :points="points"
    :balance="balance"
  )
</template>

<script>
import { mapState } from 'vuex';
import Preview from './layouts/Preview';

export default {
  components: { Preview },
  computed: {
    ...mapState('coursePointsShop', {
      points: s => s.data.points,
      balance: s => s.data.balance,
      courseName: s => s.data.courseName
    })
  },
  watch: {
    courseName() {
      this.setHeader();
    }
  },
  beforeCreate() {
    this.$store.dispatch('coursePointsShop/getShop', {
      courseId: this.$route.params.courseId
    });
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    setHeader() {
      if (this.courseName) {
        this.$store.dispatch('lms/setMultipleData', [
          { path: 'headerTitle', value: `${this.courseName}` },
          {
            path: 'headerPrevLink',
            value: '/courses/course/' + this.$route.params.courseId
          }
        ]);
      }
    }
  }
};
</script>
